import { createContext, useContext } from 'react';

/**
 * useResponsive
 * Custom hook to get the current responsive view ('mobile', 'tablet', 'desktop') from ResponsiveProvider.
 * Throws an error if used outside ResponsiveProvider.
 *
 * @returns { currentMode: 'mobile' | 'tablet' | 'desktop' }
 *
 * Usage:
 * const { currentMode } = useResponsive();
 */

export const ResponsiveContext = createContext<{ currentMode: 'mobile' | 'tablet' | 'desktop' }>({
    currentMode: 'desktop',
});

export const useResponsive = () => {
    const context = useContext(ResponsiveContext);
    if (!context) {
        throw new Error('useResponsive must be used within a ResponsiveProvider');
    }
    return context;
};
